import axios from "@/plugins/axios";

export function getAbout() {
  return axios({
    url: "Site/GetAboutPageAsync",
    method: "GET",
  });
}
